import { onCleanup, onMount, reactive } from 'cdui-js';

import { bindOverlayHistory, type OverlayHistoryHandle } from '../../../../lib/overlay-history';
import type { API, ActionSheetCloseOptions } from './index';
import { enableActionSheetScrollLock } from './scrollLock';

interface Props {
  title?: any;
  content?: any;
  contentClass?: string;
  close: any;
  api: API;
  zIndex?: number;
  canClose?: () => boolean;
}

export const ActionSheet = (props: Props) => {
  const state = reactive({
    isShow: false,
  });

  let sheetEl: HTMLElement | null = null;
  let releaseScrollLock: (() => void) | null = null;
  let history: OverlayHistoryHandle | null = null;

  const finishClose = () => {
    state.isShow = false;
    setTimeout(() => {
      props.close();
    }, 300);
  };

  const handleClose = (options?: ActionSheetCloseOptions) => {
    if (props.canClose && !props.canClose()) return;
    history?.release(options?.skipHistoryBack ? { skipBack: true } : undefined);
    history = null;
    finishClose();
  };

  onMount(() => {
    history = bindOverlayHistory(
      () => {
        history = null;
        finishClose();
      },
      props.canClose,
    );

    setTimeout(() => {
      state.isShow = true;
    }, 0);

    if (sheetEl) {
      releaseScrollLock = enableActionSheetScrollLock(sheetEl);
    }
  });

  onCleanup(() => {
    history?.release();
    history = null;
    releaseScrollLock?.();
    releaseScrollLock = null;
  });

  props.api.handleClose = handleClose;

  return (
    <div
      ref={(el: HTMLElement) => {
        sheetEl = el;
      }}
      class={`${state.isShow ? 'action-sheet action-sheet-show' : 'action-sheet action-sheet-hide'} ${props.contentClass ?? ''}`.trim()}
      onclick={() => handleClose()}
    >
      <div
        class={`action-sheet-content bg-c-L color-D ${props.contentClass ?? ''}`.trim()}
        onclick={(e) => {
          e.stopPropagation();
        }}
      >
        <div class="action-sheet-grabber" />

        {props.title && (
          <div class="action-sheet-header-row">
            <div class="action-sheet-header-title">
              {typeof props.title === 'function' ? props.title?.() : props.title}
            </div>
          </div>
        )}

        <div class="action-sheet-body">{props.content?.()}</div>
      </div>
    </div>
  );
};
